/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { FermetureTemporaireDto } from '../models/fermeture-temporaire-dto';
import { HeureOuvertureDto } from '../models/heure-ouverture-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des heures d'ouverture des recyparcs
 */
@Injectable({
  providedIn: 'root',
})
export class HeuresOuvertureRecyparcsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation heureOuvertureGet
   */
  static readonly HeureOuvertureGetPath = '/api/heures-ouverture-recyparcs/{id}';

  /**
   * Renvoie l'heure d'ouverture spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `heureOuvertureGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  heureOuvertureGet$Response(params: {

    /**
     * Identifiant de l&#x27;heure d&#x27;ouverture
     */
    id: number;
  }): Observable<StrictHttpResponse<HeureOuvertureDto>> {

    const rb = new RequestBuilder(this.rootUrl, HeuresOuvertureRecyparcsService.HeureOuvertureGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HeureOuvertureDto>;
      })
    );
  }

  /**
   * Renvoie l'heure d'ouverture spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `heureOuvertureGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  heureOuvertureGet(params: {

    /**
     * Identifiant de l&#x27;heure d&#x27;ouverture
     */
    id: number;
  }): Observable<HeureOuvertureDto> {

    return this.heureOuvertureGet$Response(params).pipe(
      map((r: StrictHttpResponse<HeureOuvertureDto>) => r.body as HeureOuvertureDto)
    );
  }

  /**
   * Path part for operation heureOuverturePut
   */
  static readonly HeureOuverturePutPath = '/api/heures-ouverture-recyparcs/{id}';

  /**
   * Met à jour l'heure d'ouverture spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `heureOuverturePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  heureOuverturePut$Response(params: {

    /**
     * Identifiant de l&#x27;heure d&#x27;ouverture à mettre à jour
     */
    id: number;

    /**
     * Heure d'ouverture
     */
    body: HeureOuvertureDto
  }): Observable<StrictHttpResponse<HeureOuvertureDto>> {

    const rb = new RequestBuilder(this.rootUrl, HeuresOuvertureRecyparcsService.HeureOuverturePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HeureOuvertureDto>;
      })
    );
  }

  /**
   * Met à jour l'heure d'ouverture spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `heureOuverturePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  heureOuverturePut(params: {

    /**
     * Identifiant de l&#x27;heure d&#x27;ouverture à mettre à jour
     */
    id: number;

    /**
     * Heure d'ouverture
     */
    body: HeureOuvertureDto
  }): Observable<HeureOuvertureDto> {

    return this.heureOuverturePut$Response(params).pipe(
      map((r: StrictHttpResponse<HeureOuvertureDto>) => r.body as HeureOuvertureDto)
    );
  }

  /**
   * Path part for operation heureOuvertureDelete
   */
  static readonly HeureOuvertureDeletePath = '/api/heures-ouverture-recyparcs/{id}';

  /**
   * Supprime l'heure d'ouverture spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `heureOuvertureDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  heureOuvertureDelete$Response(params: {

    /**
     * Identifiant de l&#x27;heure d&#x27;ouverture à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, HeuresOuvertureRecyparcsService.HeureOuvertureDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime l'heure d'ouverture spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `heureOuvertureDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  heureOuvertureDelete(params: {

    /**
     * Identifiant de l&#x27;heure d&#x27;ouverture à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.heureOuvertureDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation heureOuvertureGetList
   */
  static readonly HeureOuvertureGetListPath = '/api/heures-ouverture-recyparcs/list/{parcId}';

  /**
   * Renvoie la liste des heures d'ouverture du recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `heureOuvertureGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  heureOuvertureGetList$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<StrictHttpResponse<Array<HeureOuvertureDto>>> {

    const rb = new RequestBuilder(this.rootUrl, HeuresOuvertureRecyparcsService.HeureOuvertureGetListPath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<HeureOuvertureDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des heures d'ouverture du recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `heureOuvertureGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  heureOuvertureGetList(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<Array<HeureOuvertureDto>> {

    return this.heureOuvertureGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<HeureOuvertureDto>>) => r.body as Array<HeureOuvertureDto>)
    );
  }

  /**
   * Path part for operation heureOuvertureLoadList
   */
  static readonly HeureOuvertureLoadListPath = '/api/heures-ouverture-recyparcs/load-list/{parcId}';

  /**
   * Renvoie la liste des heures d'ouverture d'un recyparc (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `heureOuvertureLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  heureOuvertureLoadList$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, HeuresOuvertureRecyparcsService.HeureOuvertureLoadListPath, 'post');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des heures d'ouverture d'un recyparc (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `heureOuvertureLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  heureOuvertureLoadList(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.heureOuvertureLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation heureOuverturePost
   */
  static readonly HeureOuverturePostPath = '/api/heures-ouverture-recyparcs/{parcId}';

  /**
   * Crée une heure d'ouverture pour le recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `heureOuverturePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  heureOuverturePost$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Informations d'heure d'ouverture
     */
    body: HeureOuvertureDto
  }): Observable<StrictHttpResponse<FermetureTemporaireDto>> {

    const rb = new RequestBuilder(this.rootUrl, HeuresOuvertureRecyparcsService.HeureOuverturePostPath, 'post');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FermetureTemporaireDto>;
      })
    );
  }

  /**
   * Crée une heure d'ouverture pour le recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `heureOuverturePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  heureOuverturePost(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Informations d'heure d'ouverture
     */
    body: HeureOuvertureDto
  }): Observable<FermetureTemporaireDto> {

    return this.heureOuverturePost$Response(params).pipe(
      map((r: StrictHttpResponse<FermetureTemporaireDto>) => r.body as FermetureTemporaireDto)
    );
  }

  /**
   * Path part for operation heureOuvertureSetToAllParcs
   */
  static readonly HeureOuvertureSetToAllParcsPath = '/api/heures-ouverture-recyparcs/set-to-all/{parcId}';

  /**
   * Copie les heures d'ouvertures du recyparc spécifié à tous les autres recyparcs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `heureOuvertureSetToAllParcs()` instead.
   *
   * This method doesn't expect any request body.
   */
  heureOuvertureSetToAllParcs$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, HeuresOuvertureRecyparcsService.HeureOuvertureSetToAllParcsPath, 'post');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Copie les heures d'ouvertures du recyparc spécifié à tous les autres recyparcs.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `heureOuvertureSetToAllParcs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  heureOuvertureSetToAllParcs(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<number> {

    return this.heureOuvertureSetToAllParcs$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

}
